import {
    Datagrid,
    DateInput,
    downloadCSV,
    FunctionField,
    NumberField,
    SimpleList,
    TextField,
    DateField,
    ReferenceField,
    SelectInput,
} from 'react-admin';
import jsonexport from 'jsonexport/dist';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme, Chip } from '@mui/material';
import { UploadButton } from '@components/UploadButton';
import { shortOptions } from '@src/helpers/date.ext';
import { dataObject } from '@src/object.type';
import env from '@src/environment';
import { orderStatus } from '@src/entityResource';

const filters = [
    <DateInput
        key="createdAt"
        source="order.createdAt"
        alwaysOn
        variant="standard"
        sx={{ debounce: 3000 }}
    />,
    <SelectInput
        key="transactionStatus"
        source="order.transactionStatus"
        alwaysOn
        variant="standard"
        sx={{ debounce: 3000 }}
        choices={orderStatus}
    />,
];

export const OrderDetailList = () => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );

    const exporter = (goods: dataObject[]) => {
        const orderDetailExport = goods.map(od => {
            const {
                order,
                goods,
                store,
                user,
                quantity,
                sellingPrice,
                description,
                amount,
            } = od;
            const u = user as unknown as { [key: string]: string | number };
            const o = order as unknown as { [key: string]: string | number };
            const g = goods as unknown as { [key: string]: string | number };
            const s = store as unknown as { [key: string]: string | number };

            return {
                ['Kode Transaksi']: o.invoiceNo,
                ['Nama Barang']: g.name,
                Jumlah: quantity,
                ['Harga Jual']: sellingPrice,
                Total: amount,
                ['Catatan Singkat']: description,
                ['Nama Pelanggan']: s.name,
                Sales: u.name,
                ['Kasir']: '',
                Timestamp: new Date().toString(),
            };
        });

        jsonexport(
            orderDetailExport,
            {
                headers: [
                    'Kode Transaksi',
                    'Nama Barang',
                    'Jumlah',
                    'Harga Jual',
                    'Total',
                    'Catatan Singkat',
                    'Nama Pelanggan',
                    'Sales',
                    'Kasir',
                    'Timestamp',
                ],
            },
            (err, csv) => {
                downloadCSV(
                    csv,
                    `detail_pesanan_${new Date().toLocaleString(env.localFormat)}`
                );
            }
        );
    };

    return (
        <InfiniteList
            uploadButton={<UploadButton />}
            exporter={exporter}
            filtersNodes={filters}
        >
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.address}
                    tertiaryText={record => record.phone}
                />
            ) : (
                <Datagrid>
                    <ReferenceField source="createdBy" reference="users">
                        <TextField source="name" />
                    </ReferenceField>
                    <ReferenceField source="order.id" reference="order">
                        <TextField source="invoiceNo" />
                    </ReferenceField>
                    <FunctionField
                        source="order.transactionStatus"
                        render={r => (
                            <Chip
                                label={r.order.transactionStatus}
                                className={r.order.transactionStatus}
                            />
                        )}
                    />
                    <DateField
                        source="order.createdAt"
                        locales={env.localFormat}
                        options={shortOptions}
                    />
                    <ReferenceField source="storeId" reference="store">
                        <TextField source="name" />
                    </ReferenceField>
                    <ReferenceField source="goodsId" reference="goods">
                        <TextField source="name" />
                    </ReferenceField>
                    <NumberField source="quantity" />
                    <NumberField source="purchasePrice" />
                    <NumberField source="sellingPrice" />
                    <NumberField source="amount" />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
